module.exports = __webpack_public_path__ + "static/media/emedhub-logo.4a2cacf4.png";